import { render, staticRenderFns } from "./EnrollmentFee.vue?vue&type=template&id=2db28a02&scoped=true"
import script from "./EnrollmentFee.vue?vue&type=script&lang=js"
export * from "./EnrollmentFee.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentFee.vue?vue&type=style&index=0&id=2db28a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db28a02",
  null
  
)

export default component.exports